"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenSize = void 0;
var _react = require("react");
const useScreenSize = () => {
  const [screenSize, setScreenSize] = (0, _react.useState)({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  });
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      setScreenSize({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    setTimeout(handleResize, 1000);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return screenSize;
};
exports.useScreenSize = useScreenSize;